/**
 * ServiceResponse(content) 또는 HAL/직접 배열 응답에서 payload를 꺼낸다.
 * @param {unknown} responseData
 * @returns {unknown}
 */
export function unwrapServiceContent(responseData) {
  if (responseData == null) {
    return null;
  }
  if (Array.isArray(responseData)) {
    return responseData;
  }
  if (typeof responseData === 'object' && responseData.content != null) {
    return responseData.content;
  }
  return responseData;
}
